<div class="container-fluid p-2">
    <h4>{{organization?.name}} <small>- {{'org_settings' | translate}}</small></h4>

    <div class="row">

        <div class="col-md-3">
            <div class="dash-tiles row-fluid">
                <div class="dash-tile dash-tile-excellent clearfix">
                    <div class="dash-tile-header">{{'number_of_team' | translate}}</div>
                    <div class="dash-tile-icon">
                        <i class="far fa-building"></i>
                    </div>
                    <div class="dash-tile-text">
                        {{organization?.teams.length}}
                    </div>
                </div>
                <div class="dash-tile dash-tile-good clearfix">
                    <div class="dash-tile-header">{{'number_of_people' | translate}}</div>
                    <div class="dash-tile-icon">
                        <i class="far fa-users"></i>
                    </div>
                    <div class="dash-tile-text">
                        {{organization?.activeMembersCount}}
                    </div>
                </div>
                @if(organization?.maxUsers){
                <div class="dash-tile dash-tile-average clearfix">
                    <div class="dash-tile-header">{{'capacity' | translate}}</div>
                    <div class="dash-tile-icon">
                        <i class="far fa-lock"></i>
                    </div>
                    <div class="dash-tile-text">
                        {{organization?.maxUsers}}
                    </div>
                </div>
                }
            </div>
        </div>

        <div class="col-md-9">
            <div class="d-flex justify-content-between mb-3">
                <h3 class="page-header">{{organization?.name}} - {{'org_settings' | translate}}</h3>
                <div>
                    <button [routerLink]="['/admin/organization', $safeNavigationMigration(organization?.id)]" class="btn btn-default"><i
                            class="far fa-users"></i> {{'team_list' | translate}}</button>
                    <button [routerLink]="['/admin/organization', $safeNavigationMigration(organization?.id), 'team', 'new']" class="btn btn-primary"><i class="far fa-plus"></i> {{'create_team' | translate}}</button>
                </div>
            </div>

            <form class="form-horizontal form-box" [formGroup]="form">
                <div class="form-box-content">

                    <div class="form-group  ">
                        <label class="control-label col-md-2" for="orgName">{{'orgName' | translate}}</label>
                        <div class="col-md-3">
                            <input type="text" id="orgName" name="orgName" formControlName="name" class="form-control"/>
                        </div>
                    </div>


                    <div class="form-group  ">
                        <label class="control-label col-md-2" for="retention">{{'retention_duration' | translate}}</label>
                        <div class="col-md-3">
                            <mat-select id="retention" formControlName="retention" class="form-select">
                                @for(retention of retentions; track retention){
                                    <mat-option [value]="retention.value">{{retention.label}}</mat-option>
                                }
                            </mat-select>
                        </div>
                        <div class="col-md-5">
                            <p>{{'retention_duration_help' | translate}}<br>
                                <a href="javascript:void(0)" (click)="contact_us()">{{'please_contact_us' | translate}}</a>
                            </p>
                        </div>
                    </div>


                    <div class="form-group form-actions">
                        <div class="col-md-3 col-md-offset-2">
                            <button class="btn btn-primary" (click)="updateOrg()" [disabled]="form.invalid"><i class="far fa-check"></i>&nbsp;{{'update' | translate}}
                            </button>
                        </div>
                        @if(alert?.show){
                        <div class="col-md-7">
                            <div class="alert {{alert.style}}">{{alert.message}}</div>
                        </div>
                        }
                    </div>
                </div>
            </form>

        </div>
    </div>
</div>
